(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['torso/modules/Collection', './TabletModel', 'app/urls'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    module.exports = factory(require('backbone-torso/modules/Collection'), require('./TabletModel'), require('./../urls'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (TorsoCollection, TabletModel, urls) {
  'use strict';

  /**
   * @class tabletCollection
   * @static
   * @extends Torso.Collection
   */
  return new (TorsoCollection.extend({
    model: TabletModel,
    url: urls.tabletExtService,
    fetchHttpAction: 'POST'
  }))();
}));
